'use client';

import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["className", "size", "value"];
import * as React from 'react';
import * as ProgressPrimitive from '@radix-ui/react-progress';
import { cva } from 'class-variance-authority';
import { cn } from "../utils";
import { jsx as _jsx } from "react/jsx-runtime";
var size = {
  sm: 'tw-h-0.4',
  md: 'tw-h-0.8'
};
var progressBarVariants = /*#__PURE__*/cva('tw-relative tw-full tw-overflow-hidden tw-bg-neutral-light-500 dark:tw-bg-neutral-dark-400', {
  variants: {
    size: {
      sm: 'tw-h-0.4',
      md: 'tw-h-0.8'
    }
  },
  defaultVariants: {
    size: 'sm'
  }
});
var ProgressBar = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var className = _ref.className,
    size = _ref.size,
    value = _ref.value,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsx(ProgressPrimitive.Root, _objectSpread(_objectSpread({
    ref: ref,
    className: cn(progressBarVariants({
      size: size,
      className: className
    }))
  }, props), {}, {
    children: /*#__PURE__*/_jsx(ProgressPrimitive.Indicator, {
      className: "tw-h-full tw-w-full tw-flex-1 tw-bg-primary-light-500 tw-transition-all dark:tw-bg-primary-light-400 tw-rounded-r-1",
      style: {
        transform: "translateX(-".concat(100 - (value !== null && value !== void 0 ? value : 0), "%)")
      }
    })
  }));
});
ProgressBar.displayName = ProgressPrimitive.Root.displayName;
export { ProgressBar };